import { Component, Input, OnInit } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'app-description-recruitment-config',
  templateUrl: './description-recruitment-config.component.html',
  styleUrls: ['./description-recruitment-config.component.scss']
})
export class DescriptionRecruitmentConfigComponent implements OnInit {
  @Input() objectChoosing: any;
  @Input() class: any;
  @Input() device: any; 
  

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
  ) { 
    
  }

  ngOnInit() {
    // console.log('objectChoosing', this.objectChoosing);
  }

    /**
   *Hàm update class vào database.
   */
   updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        console.log('updateClass', bool);
      })
  }

}
